// ES module version for Vite
// This is a standalone ES6 module that mirrors mockEmptyModule.js for Vite builds
const mockComponent = () => null;
const mockObject = {};

// React Native Core Components
export const View = mockComponent;
export const Text = mockComponent;
export const Image = mockComponent;
export const TouchableOpacity = mockComponent;
export const TouchableWithoutFeedback = mockComponent;
export const Pressable = mockComponent;
export const ScrollView = mockComponent;
export const FlatList = mockComponent;
export const SectionList = mockComponent;
export const SafeAreaView = mockComponent;
export const Modal = mockComponent;
export const Button = mockComponent;
export const TextInput = mockComponent;
export const Switch = mockComponent;
export const ActivityIndicator = mockComponent;
export const KeyboardAvoidingView = mockComponent;
export const RefreshControl = mockComponent;

// React Native APIs
export const Platform = { OS: 'web', select: (obj) => obj.web || obj.default };
export const Dimensions = { get: () => ({ width: 1024, height: 768 }) };
export const StyleSheet = { create: (styles) => styles, flatten: (style) => style };
export const PixelRatio = { get: () => 1 };
export const Animated = {
  View: mockComponent,
  Text: mockComponent,
  Value: class { constructor() {} },
  timing: () => ({ start: () => {} }),
  spring: () => ({ start: () => {} }),
  parallel: () => ({ start: () => {} }),
  sequence: () => ({ start: () => {} })
};
export const Easing = mockObject;
export const Keyboard = { dismiss: () => {}, addListener: () => ({ remove: () => {} }) };
export const BackHandler = { addEventListener: () => ({ remove: () => {} }) };
export const AppState = { addEventListener: () => ({ remove: () => {} }), currentState: 'active' };
export const Linking = { openURL: () => Promise.resolve(), canOpenURL: () => Promise.resolve(true) };
export const Alert = { alert: () => {} };
export const LogBox = {
  install: () => {},
  uninstall: () => {},
  ignoreLogs: () => {},
  ignoreAllLogs: () => {},
};
export class NativeEventEmitter {
  constructor() {}
  addListener() {
    return { remove: () => {} };
  }
}
export const NativeModule = mockObject;
export const NativeModules = mockObject;
export const InteractionManager = {
  runAfterInteractions: (callback) => {
    if (callback) callback();
    return { cancel: () => {} };
  },
};
export const PermissionsAndroid = mockObject;
export const I18nManager = { isRTL: false, allowRTL: () => {}, forceRTL: () => {} };
export const PanResponder = {
  create: () => ({
    panHandlers: {},
  }),
};

// React Native UI Lib
export const Colors = { rgba: () => null };
export const Spacings = mockObject;
export const Typography = mockObject;
export const Picker = mockComponent;
export const DateTimePicker = mockComponent;
export const Checkbox = mockComponent;
export const TextField = mockComponent;
export const ExpandableOverlay = mockComponent;
export const Incubator = mockObject;
export const Toast = mockComponent;
export const Fader = mockComponent;
export const FaderPosition = mockObject;

// Mobile Theme
export const mobileStyles = mockObject;
export const commonStyles = mockObject;
export const AppSpacings = mockObject;
export const inputStyles = mockObject;
export const ToastType = mockObject;
export const useToastService = () => ({ show: () => {} });

// React Native Safe Area Context
export const useSafeAreaInsets = () => ({ top: 0, right: 0, bottom: 0, left: 0 });
export const useSafeAreaFrame = () => ({ x: 0, y: 0, width: 1024, height: 768 });
export const initialWindowMetrics = {
  frame: { x: 0, y: 0, width: 1024, height: 768 },
  insets: { top: 0, left: 0, right: 0, bottom: 0 },
};
export const SafeAreaFrameContext = { Provider: mockComponent, Consumer: mockComponent };
export const SafeAreaInsetsContext = { Provider: mockComponent, Consumer: mockComponent };
export const SafeAreaProvider = mockComponent;

// React Native Gesture Handler
export const Gesture = mockObject;
export const GestureDetector = mockComponent;
export const State = mockObject;

// React Native functions
export const findNodeHandle = () => null;

// React Native Reanimated functions
export const interpolate = () => 0;
export const runOnJS = (fn) => (...args) => fn(...args);
export const runOnUI = (fn) => (...args) => fn(...args);

// Additional mobile-specific components
export const CalendarLinksBlockLayout = mockComponent;

// Default export
export default mockComponent;
